// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as StudyAbroadRouteImport } from './routes/study-abroad'
import { Route as StartRouteImport } from './routes/start'
import { Route as RedeemRouteImport } from './routes/redeem'
import { Route as PaymentReturnRouteImport } from './routes/payment-return'
import { Route as Diag1822RouteImport } from './routes/diag1822'
import { Route as CoachesRouteImport } from './routes/coaches'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as CabinetRouteImport } from './routes/cabinet'
import { Route as BesplatnyyTestProforientatsiiRouteImport } from './routes/besplatnyy-test-proforientatsii'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TutorsIndexRouteImport } from './routes/tutors.index'
import { Route as RuIndexRouteImport } from './routes/ru.index'
import { Route as EnIndexRouteImport } from './routes/en.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as AzIndexRouteImport } from './routes/az.index'
import { Route as TutorsJoinRouteImport } from './routes/tutors.join'
import { Route as TutorsSlugRouteImport } from './routes/tutors.$slug'
import { Route as StudyAbroadStartRouteImport } from './routes/study-abroad_.start'
import { Route as SessionTokenRouteImport } from './routes/session.$token'
import { Route as RuShkolamRouteImport } from './routes/ru.shkolam'
import { Route as PulseTokenRouteImport } from './routes/pulse.$token'
import { Route as EnStudyAbroadRouteImport } from './routes/en.study-abroad'
import { Route as EnSchoolsRouteImport } from './routes/en.schools'
import { Route as EnFreeCareerTestRouteImport } from './routes/en.free-career-test'
import { Route as EnCoachesRouteImport } from './routes/en.coaches'
import { Route as EnCareersRouteImport } from './routes/en.careers'
import { Route as CabinetJoinRouteImport } from './routes/cabinet_.join'
import { Route as CabinetEduReportRouteImport } from './routes/cabinet_.edu-report'
import { Route as CabinetEduConsultRouteImport } from './routes/cabinet_.edu-consult'
import { Route as CabinetEduRouteImport } from './routes/cabinet_.edu'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AzXaricdeTehsilRouteImport } from './routes/az.xaricde-tehsil'
import { Route as AzPulsuzKaryeraTestiRouteImport } from './routes/az.pulsuz-karyera-testi'
import { Route as AzMekteblerRouteImport } from './routes/az.mektebler'
import { Route as AzCoachesRouteImport } from './routes/az.coaches'
import { Route as AzCareersRouteImport } from './routes/az.careers'
import { Route as AuthCallbackRouteImport } from './routes/auth_.callback'
import { Route as AdminDeletionsRouteImport } from './routes/admin_.deletions'
import { Route as AbroadReportTokenRouteImport } from './routes/abroad-report.$token'
import { Route as RedeemIndexRouteImport } from './routes/redeem.index'
import { Route as RedeemCodeRouteImport } from './routes/redeem.$code'
import { Route as CareersIndexRouteImport } from './routes/careers.index'
import { Route as CareersSphereRouteImport } from './routes/careers.$sphere'
import { Route as RuTutorsIndexRouteImport } from './routes/ru.tutors.index'
import { Route as EnTutorsIndexRouteImport } from './routes/en.tutors.index'
import { Route as EnBlogIndexRouteImport } from './routes/en.blog.index'
import { Route as AzTutorsIndexRouteImport } from './routes/az.tutors.index'
import { Route as AzBloqIndexRouteImport } from './routes/az.bloq.index'
import { Route as AdminReviewIndexRouteImport } from './routes/admin_.review.index'
import { Route as StudyAbroadRTokenRouteImport } from './routes/study-abroad_.r.$token'
import { Route as StudyAbroadInviteTokenRouteImport } from './routes/study-abroad_.invite.$token'
import { Route as RuTutorsSavedRouteImport } from './routes/ru.tutors.saved'
import { Route as RuTutorsMeRouteImport } from './routes/ru.tutors.me'
import { Route as RuTutorsJoinRouteImport } from './routes/ru.tutors.join'
import { Route as RuTutorsSlugRouteImport } from './routes/ru.tutors.$slug'
import { Route as Report18PlusPreviewPearsonRouteImport } from './routes/report.18-plus.preview-pearson'
import { Route as Report18PlusPreviewRouteImport } from './routes/report.18-plus.preview'
import { Route as Report1618PreviewRouteImport } from './routes/report.16-18.preview'
import { Route as Report1415PreviewRouteImport } from './routes/report.14-15.preview'
import { Route as Report1213PreviewRouteImport } from './routes/report.12-13.preview'
import { Route as Report1011PreviewRouteImport } from './routes/report.10-11.preview'
import { Route as EnTutorsSavedRouteImport } from './routes/en.tutors.saved'
import { Route as EnTutorsMeRouteImport } from './routes/en.tutors.me'
import { Route as EnTutorsJoinRouteImport } from './routes/en.tutors.join'
import { Route as EnTutorsSlugRouteImport } from './routes/en.tutors.$slug'
import { Route as EnStudyAbroadStartRouteImport } from './routes/en.study-abroad_.start'
import { Route as EnBlogSlugRouteImport } from './routes/en.blog.$slug'
import { Route as AzXaricdeTehsilStartRouteImport } from './routes/az.xaricde-tehsil_.start'
import { Route as AzTutorsSavedRouteImport } from './routes/az.tutors.saved'
import { Route as AzTutorsMeRouteImport } from './routes/az.tutors.me'
import { Route as AzTutorsJoinRouteImport } from './routes/az.tutors.join'
import { Route as AzTutorsSlugRouteImport } from './routes/az.tutors.$slug'
import { Route as AzBloqSlugRouteImport } from './routes/az.bloq.$slug'
import { Route as AdminReviewIdRouteImport } from './routes/admin_.review.$id'
import { Route as SessionTokenTestRouteImport } from './routes/session.$token.test'
import { Route as SessionTokenResultRouteImport } from './routes/session.$token.result'
import { Route as SessionTokenPrintRouteImport } from './routes/session.$token.print'
import { Route as EnCareersIndexRouteImport } from './routes/en.careers.index'
import { Route as EnCareersSphereRouteImport } from './routes/en.careers.$sphere'
import { Route as AzCareersIndexRouteImport } from './routes/az.careers.index'
import { Route as AzCareersSphereRouteImport } from './routes/az.careers.$sphere'
import { Route as CareersSphereCareerRouteImport } from './routes/careers.$sphere_.$career'
import { Route as RuTutorsMeEditRouteImport } from './routes/ru.tutors.me_.edit'
import { Route as RuTutorsJoinSentRouteImport } from './routes/ru.tutors.join_.sent'
import { Route as EnTutorsMeEditRouteImport } from './routes/en.tutors.me_.edit'
import { Route as EnTutorsJoinSentRouteImport } from './routes/en.tutors.join_.sent'
import { Route as EnStudyAbroadRTokenRouteImport } from './routes/en.study-abroad_.r.$token'
import { Route as EnStudyAbroadInviteTokenRouteImport } from './routes/en.study-abroad_.invite.$token'
import { Route as AzXaricdeTehsilRTokenRouteImport } from './routes/az.xaricde-tehsil_.r.$token'
import { Route as AzXaricdeTehsilDevetTokenRouteImport } from './routes/az.xaricde-tehsil_.devet.$token'
import { Route as AzTutorsMeEditRouteImport } from './routes/az.tutors.me_.edit'
import { Route as AzTutorsJoinSentRouteImport } from './routes/az.tutors.join_.sent'
import { Route as EnCareersSphereCareerRouteImport } from './routes/en.careers.$sphere_.$career'
import { Route as AzCareersSphereCareerRouteImport } from './routes/az.careers.$sphere_.$career'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const StudyAbroadRoute = StudyAbroadRouteImport.update({
            id: '/study-abroad',path: '/study-abroad',getParentRoute: () => rootRouteImport
          })
const StartRoute = StartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => rootRouteImport
          })
const RedeemRoute = RedeemRouteImport.update({
            id: '/redeem',path: '/redeem',getParentRoute: () => rootRouteImport
          })
const PaymentReturnRoute = PaymentReturnRouteImport.update({
            id: '/payment-return',path: '/payment-return',getParentRoute: () => rootRouteImport
          })
const Diag1822Route = Diag1822RouteImport.update({
            id: '/diag1822',path: '/diag1822',getParentRoute: () => rootRouteImport
          })
const CoachesRoute = CoachesRouteImport.update({
            id: '/coaches',path: '/coaches',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const CabinetRoute = CabinetRouteImport.update({
            id: '/cabinet',path: '/cabinet',getParentRoute: () => rootRouteImport
          })
const BesplatnyyTestProforientatsiiRoute = BesplatnyyTestProforientatsiiRouteImport.update({
            id: '/besplatnyy-test-proforientatsii',path: '/besplatnyy-test-proforientatsii',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const TutorsIndexRoute = TutorsIndexRouteImport.update({
            id: '/tutors/',path: '/tutors/',getParentRoute: () => rootRouteImport
          })
const RuIndexRoute = RuIndexRouteImport.update({
            id: '/ru/',path: '/ru/',getParentRoute: () => rootRouteImport
          })
const EnIndexRoute = EnIndexRouteImport.update({
            id: '/en/',path: '/en/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const AzIndexRoute = AzIndexRouteImport.update({
            id: '/az/',path: '/az/',getParentRoute: () => rootRouteImport
          })
const TutorsJoinRoute = TutorsJoinRouteImport.update({
            id: '/tutors/join',path: '/tutors/join',getParentRoute: () => rootRouteImport
          })
const TutorsSlugRoute = TutorsSlugRouteImport.update({
            id: '/tutors/$slug',path: '/tutors/$slug',getParentRoute: () => rootRouteImport
          })
const StudyAbroadStartRoute = StudyAbroadStartRouteImport.update({
            id: '/study-abroad_/start',path: '/study-abroad/start',getParentRoute: () => rootRouteImport
          })
const SessionTokenRoute = SessionTokenRouteImport.update({
            id: '/session/$token',path: '/session/$token',getParentRoute: () => rootRouteImport
          })
const RuShkolamRoute = RuShkolamRouteImport.update({
            id: '/ru/shkolam',path: '/ru/shkolam',getParentRoute: () => rootRouteImport
          })
const PulseTokenRoute = PulseTokenRouteImport.update({
            id: '/pulse/$token',path: '/pulse/$token',getParentRoute: () => rootRouteImport
          })
const EnStudyAbroadRoute = EnStudyAbroadRouteImport.update({
            id: '/en/study-abroad',path: '/en/study-abroad',getParentRoute: () => rootRouteImport
          })
const EnSchoolsRoute = EnSchoolsRouteImport.update({
            id: '/en/schools',path: '/en/schools',getParentRoute: () => rootRouteImport
          })
const EnFreeCareerTestRoute = EnFreeCareerTestRouteImport.update({
            id: '/en/free-career-test',path: '/en/free-career-test',getParentRoute: () => rootRouteImport
          })
const EnCoachesRoute = EnCoachesRouteImport.update({
            id: '/en/coaches',path: '/en/coaches',getParentRoute: () => rootRouteImport
          })
const EnCareersRoute = EnCareersRouteImport.update({
            id: '/en/careers',path: '/en/careers',getParentRoute: () => rootRouteImport
          })
const CabinetJoinRoute = CabinetJoinRouteImport.update({
            id: '/cabinet_/join',path: '/cabinet/join',getParentRoute: () => rootRouteImport
          })
const CabinetEduReportRoute = CabinetEduReportRouteImport.update({
            id: '/cabinet_/edu-report',path: '/cabinet/edu-report',getParentRoute: () => rootRouteImport
          })
const CabinetEduConsultRoute = CabinetEduConsultRouteImport.update({
            id: '/cabinet_/edu-consult',path: '/cabinet/edu-consult',getParentRoute: () => rootRouteImport
          })
const CabinetEduRoute = CabinetEduRouteImport.update({
            id: '/cabinet_/edu',path: '/cabinet/edu',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const AzXaricdeTehsilRoute = AzXaricdeTehsilRouteImport.update({
            id: '/az/xaricde-tehsil',path: '/az/xaricde-tehsil',getParentRoute: () => rootRouteImport
          })
const AzPulsuzKaryeraTestiRoute = AzPulsuzKaryeraTestiRouteImport.update({
            id: '/az/pulsuz-karyera-testi',path: '/az/pulsuz-karyera-testi',getParentRoute: () => rootRouteImport
          })
const AzMekteblerRoute = AzMekteblerRouteImport.update({
            id: '/az/mektebler',path: '/az/mektebler',getParentRoute: () => rootRouteImport
          })
const AzCoachesRoute = AzCoachesRouteImport.update({
            id: '/az/coaches',path: '/az/coaches',getParentRoute: () => rootRouteImport
          })
const AzCareersRoute = AzCareersRouteImport.update({
            id: '/az/careers',path: '/az/careers',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth_/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const AdminDeletionsRoute = AdminDeletionsRouteImport.update({
            id: '/admin_/deletions',path: '/admin/deletions',getParentRoute: () => rootRouteImport
          })
const AbroadReportTokenRoute = AbroadReportTokenRouteImport.update({
            id: '/abroad-report/$token',path: '/abroad-report/$token',getParentRoute: () => rootRouteImport
          })
const RedeemIndexRoute = RedeemIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RedeemRoute
          })
const RedeemCodeRoute = RedeemCodeRouteImport.update({
            id: '/$code',path: '/$code',getParentRoute: () => RedeemRoute
          })
const CareersIndexRoute = CareersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CareersRoute
          })
const CareersSphereRoute = CareersSphereRouteImport.update({
            id: '/$sphere',path: '/$sphere',getParentRoute: () => CareersRoute
          })
const RuTutorsIndexRoute = RuTutorsIndexRouteImport.update({
            id: '/ru/tutors/',path: '/ru/tutors/',getParentRoute: () => rootRouteImport
          })
const EnTutorsIndexRoute = EnTutorsIndexRouteImport.update({
            id: '/en/tutors/',path: '/en/tutors/',getParentRoute: () => rootRouteImport
          })
const EnBlogIndexRoute = EnBlogIndexRouteImport.update({
            id: '/en/blog/',path: '/en/blog/',getParentRoute: () => rootRouteImport
          })
const AzTutorsIndexRoute = AzTutorsIndexRouteImport.update({
            id: '/az/tutors/',path: '/az/tutors/',getParentRoute: () => rootRouteImport
          })
const AzBloqIndexRoute = AzBloqIndexRouteImport.update({
            id: '/az/bloq/',path: '/az/bloq/',getParentRoute: () => rootRouteImport
          })
const AdminReviewIndexRoute = AdminReviewIndexRouteImport.update({
            id: '/admin_/review/',path: '/admin/review/',getParentRoute: () => rootRouteImport
          })
const StudyAbroadRTokenRoute = StudyAbroadRTokenRouteImport.update({
            id: '/study-abroad_/r/$token',path: '/study-abroad/r/$token',getParentRoute: () => rootRouteImport
          })
const StudyAbroadInviteTokenRoute = StudyAbroadInviteTokenRouteImport.update({
            id: '/study-abroad_/invite/$token',path: '/study-abroad/invite/$token',getParentRoute: () => rootRouteImport
          })
const RuTutorsSavedRoute = RuTutorsSavedRouteImport.update({
            id: '/ru/tutors/saved',path: '/ru/tutors/saved',getParentRoute: () => rootRouteImport
          })
const RuTutorsMeRoute = RuTutorsMeRouteImport.update({
            id: '/ru/tutors/me',path: '/ru/tutors/me',getParentRoute: () => rootRouteImport
          })
const RuTutorsJoinRoute = RuTutorsJoinRouteImport.update({
            id: '/ru/tutors/join',path: '/ru/tutors/join',getParentRoute: () => rootRouteImport
          })
const RuTutorsSlugRoute = RuTutorsSlugRouteImport.update({
            id: '/ru/tutors/$slug',path: '/ru/tutors/$slug',getParentRoute: () => rootRouteImport
          })
const Report18PlusPreviewPearsonRoute = Report18PlusPreviewPearsonRouteImport.update({
            id: '/report/18-plus/preview-pearson',path: '/report/18-plus/preview-pearson',getParentRoute: () => rootRouteImport
          })
const Report18PlusPreviewRoute = Report18PlusPreviewRouteImport.update({
            id: '/report/18-plus/preview',path: '/report/18-plus/preview',getParentRoute: () => rootRouteImport
          })
const Report1618PreviewRoute = Report1618PreviewRouteImport.update({
            id: '/report/16-18/preview',path: '/report/16-18/preview',getParentRoute: () => rootRouteImport
          })
const Report1415PreviewRoute = Report1415PreviewRouteImport.update({
            id: '/report/14-15/preview',path: '/report/14-15/preview',getParentRoute: () => rootRouteImport
          })
const Report1213PreviewRoute = Report1213PreviewRouteImport.update({
            id: '/report/12-13/preview',path: '/report/12-13/preview',getParentRoute: () => rootRouteImport
          })
const Report1011PreviewRoute = Report1011PreviewRouteImport.update({
            id: '/report/10-11/preview',path: '/report/10-11/preview',getParentRoute: () => rootRouteImport
          })
const EnTutorsSavedRoute = EnTutorsSavedRouteImport.update({
            id: '/en/tutors/saved',path: '/en/tutors/saved',getParentRoute: () => rootRouteImport
          })
const EnTutorsMeRoute = EnTutorsMeRouteImport.update({
            id: '/en/tutors/me',path: '/en/tutors/me',getParentRoute: () => rootRouteImport
          })
const EnTutorsJoinRoute = EnTutorsJoinRouteImport.update({
            id: '/en/tutors/join',path: '/en/tutors/join',getParentRoute: () => rootRouteImport
          })
const EnTutorsSlugRoute = EnTutorsSlugRouteImport.update({
            id: '/en/tutors/$slug',path: '/en/tutors/$slug',getParentRoute: () => rootRouteImport
          })
const EnStudyAbroadStartRoute = EnStudyAbroadStartRouteImport.update({
            id: '/en/study-abroad_/start',path: '/en/study-abroad/start',getParentRoute: () => rootRouteImport
          })
const EnBlogSlugRoute = EnBlogSlugRouteImport.update({
            id: '/en/blog/$slug',path: '/en/blog/$slug',getParentRoute: () => rootRouteImport
          })
const AzXaricdeTehsilStartRoute = AzXaricdeTehsilStartRouteImport.update({
            id: '/az/xaricde-tehsil_/start',path: '/az/xaricde-tehsil/start',getParentRoute: () => rootRouteImport
          })
const AzTutorsSavedRoute = AzTutorsSavedRouteImport.update({
            id: '/az/tutors/saved',path: '/az/tutors/saved',getParentRoute: () => rootRouteImport
          })
const AzTutorsMeRoute = AzTutorsMeRouteImport.update({
            id: '/az/tutors/me',path: '/az/tutors/me',getParentRoute: () => rootRouteImport
          })
const AzTutorsJoinRoute = AzTutorsJoinRouteImport.update({
            id: '/az/tutors/join',path: '/az/tutors/join',getParentRoute: () => rootRouteImport
          })
const AzTutorsSlugRoute = AzTutorsSlugRouteImport.update({
            id: '/az/tutors/$slug',path: '/az/tutors/$slug',getParentRoute: () => rootRouteImport
          })
const AzBloqSlugRoute = AzBloqSlugRouteImport.update({
            id: '/az/bloq/$slug',path: '/az/bloq/$slug',getParentRoute: () => rootRouteImport
          })
const AdminReviewIdRoute = AdminReviewIdRouteImport.update({
            id: '/admin_/review/$id',path: '/admin/review/$id',getParentRoute: () => rootRouteImport
          })
const SessionTokenTestRoute = SessionTokenTestRouteImport.update({
            id: '/test',path: '/test',getParentRoute: () => SessionTokenRoute
          })
const SessionTokenResultRoute = SessionTokenResultRouteImport.update({
            id: '/result',path: '/result',getParentRoute: () => SessionTokenRoute
          })
const SessionTokenPrintRoute = SessionTokenPrintRouteImport.update({
            id: '/print',path: '/print',getParentRoute: () => SessionTokenRoute
          })
const EnCareersIndexRoute = EnCareersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EnCareersRoute
          })
const EnCareersSphereRoute = EnCareersSphereRouteImport.update({
            id: '/$sphere',path: '/$sphere',getParentRoute: () => EnCareersRoute
          })
const AzCareersIndexRoute = AzCareersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AzCareersRoute
          })
const AzCareersSphereRoute = AzCareersSphereRouteImport.update({
            id: '/$sphere',path: '/$sphere',getParentRoute: () => AzCareersRoute
          })
const CareersSphereCareerRoute = CareersSphereCareerRouteImport.update({
            id: '/$sphere_/$career',path: '/$sphere/$career',getParentRoute: () => CareersRoute
          })
const RuTutorsMeEditRoute = RuTutorsMeEditRouteImport.update({
            id: '/ru/tutors/me_/edit',path: '/ru/tutors/me/edit',getParentRoute: () => rootRouteImport
          })
const RuTutorsJoinSentRoute = RuTutorsJoinSentRouteImport.update({
            id: '/ru/tutors/join_/sent',path: '/ru/tutors/join/sent',getParentRoute: () => rootRouteImport
          })
const EnTutorsMeEditRoute = EnTutorsMeEditRouteImport.update({
            id: '/en/tutors/me_/edit',path: '/en/tutors/me/edit',getParentRoute: () => rootRouteImport
          })
const EnTutorsJoinSentRoute = EnTutorsJoinSentRouteImport.update({
            id: '/en/tutors/join_/sent',path: '/en/tutors/join/sent',getParentRoute: () => rootRouteImport
          })
const EnStudyAbroadRTokenRoute = EnStudyAbroadRTokenRouteImport.update({
            id: '/en/study-abroad_/r/$token',path: '/en/study-abroad/r/$token',getParentRoute: () => rootRouteImport
          })
const EnStudyAbroadInviteTokenRoute = EnStudyAbroadInviteTokenRouteImport.update({
            id: '/en/study-abroad_/invite/$token',path: '/en/study-abroad/invite/$token',getParentRoute: () => rootRouteImport
          })
const AzXaricdeTehsilRTokenRoute = AzXaricdeTehsilRTokenRouteImport.update({
            id: '/az/xaricde-tehsil_/r/$token',path: '/az/xaricde-tehsil/r/$token',getParentRoute: () => rootRouteImport
          })
const AzXaricdeTehsilDevetTokenRoute = AzXaricdeTehsilDevetTokenRouteImport.update({
            id: '/az/xaricde-tehsil_/devet/$token',path: '/az/xaricde-tehsil/devet/$token',getParentRoute: () => rootRouteImport
          })
const AzTutorsMeEditRoute = AzTutorsMeEditRouteImport.update({
            id: '/az/tutors/me_/edit',path: '/az/tutors/me/edit',getParentRoute: () => rootRouteImport
          })
const AzTutorsJoinSentRoute = AzTutorsJoinSentRouteImport.update({
            id: '/az/tutors/join_/sent',path: '/az/tutors/join/sent',getParentRoute: () => rootRouteImport
          })
const EnCareersSphereCareerRoute = EnCareersSphereCareerRouteImport.update({
            id: '/$sphere_/$career',path: '/$sphere/$career',getParentRoute: () => EnCareersRoute
          })
const AzCareersSphereCareerRoute = AzCareersSphereCareerRouteImport.update({
            id: '/$sphere_/$career',path: '/$sphere/$career',getParentRoute: () => AzCareersRoute
          })





const CareersRouteChildren = {
  CareersSphereRoute: CareersSphereRoute,CareersIndexRoute: CareersIndexRoute,CareersSphereCareerRoute: CareersSphereCareerRoute
}

const CareersRouteWithChildren = CareersRoute._addFileChildren(CareersRouteChildren)




const RedeemRouteChildren = {
  RedeemCodeRoute: RedeemCodeRoute,RedeemIndexRoute: RedeemIndexRoute
}

const RedeemRouteWithChildren = RedeemRoute._addFileChildren(RedeemRouteChildren)




const AzCareersRouteChildren = {
  AzCareersSphereRoute: AzCareersSphereRoute,AzCareersIndexRoute: AzCareersIndexRoute,AzCareersSphereCareerRoute: AzCareersSphereCareerRoute
}

const AzCareersRouteWithChildren = AzCareersRoute._addFileChildren(AzCareersRouteChildren)




const EnCareersRouteChildren = {
  EnCareersSphereRoute: EnCareersSphereRoute,EnCareersIndexRoute: EnCareersIndexRoute,EnCareersSphereCareerRoute: EnCareersSphereCareerRoute
}

const EnCareersRouteWithChildren = EnCareersRoute._addFileChildren(EnCareersRouteChildren)




const SessionTokenRouteChildren = {
  SessionTokenPrintRoute: SessionTokenPrintRoute,SessionTokenResultRoute: SessionTokenResultRoute,SessionTokenTestRoute: SessionTokenTestRoute
}

const SessionTokenRouteWithChildren = SessionTokenRoute._addFileChildren(SessionTokenRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRoute,AuthRoute: AuthRoute,BesplatnyyTestProforientatsiiRoute: BesplatnyyTestProforientatsiiRoute,CabinetRoute: CabinetRoute,CareersRoute: CareersRouteWithChildren,CoachesRoute: CoachesRoute,Diag1822Route: Diag1822Route,PaymentReturnRoute: PaymentReturnRoute,RedeemRoute: RedeemRouteWithChildren,StartRoute: StartRoute,StudyAbroadRoute: StudyAbroadRoute,UnsubscribeRoute: UnsubscribeRoute,AbroadReportTokenRoute: AbroadReportTokenRoute,AdminDeletionsRoute: AdminDeletionsRoute,AuthCallbackRoute: AuthCallbackRoute,AzCareersRoute: AzCareersRouteWithChildren,AzCoachesRoute: AzCoachesRoute,AzMekteblerRoute: AzMekteblerRoute,AzPulsuzKaryeraTestiRoute: AzPulsuzKaryeraTestiRoute,AzXaricdeTehsilRoute: AzXaricdeTehsilRoute,BlogSlugRoute: BlogSlugRoute,CabinetEduRoute: CabinetEduRoute,CabinetEduConsultRoute: CabinetEduConsultRoute,CabinetEduReportRoute: CabinetEduReportRoute,CabinetJoinRoute: CabinetJoinRoute,EnCareersRoute: EnCareersRouteWithChildren,EnCoachesRoute: EnCoachesRoute,EnFreeCareerTestRoute: EnFreeCareerTestRoute,EnSchoolsRoute: EnSchoolsRoute,EnStudyAbroadRoute: EnStudyAbroadRoute,PulseTokenRoute: PulseTokenRoute,RuShkolamRoute: RuShkolamRoute,SessionTokenRoute: SessionTokenRouteWithChildren,StudyAbroadStartRoute: StudyAbroadStartRoute,TutorsSlugRoute: TutorsSlugRoute,TutorsJoinRoute: TutorsJoinRoute,AzIndexRoute: AzIndexRoute,BlogIndexRoute: BlogIndexRoute,EnIndexRoute: EnIndexRoute,RuIndexRoute: RuIndexRoute,TutorsIndexRoute: TutorsIndexRoute,AdminReviewIdRoute: AdminReviewIdRoute,AzBloqSlugRoute: AzBloqSlugRoute,AzTutorsSlugRoute: AzTutorsSlugRoute,AzTutorsJoinRoute: AzTutorsJoinRoute,AzTutorsMeRoute: AzTutorsMeRoute,AzTutorsSavedRoute: AzTutorsSavedRoute,AzXaricdeTehsilStartRoute: AzXaricdeTehsilStartRoute,EnBlogSlugRoute: EnBlogSlugRoute,EnStudyAbroadStartRoute: EnStudyAbroadStartRoute,EnTutorsSlugRoute: EnTutorsSlugRoute,EnTutorsJoinRoute: EnTutorsJoinRoute,EnTutorsMeRoute: EnTutorsMeRoute,EnTutorsSavedRoute: EnTutorsSavedRoute,Report1011PreviewRoute: Report1011PreviewRoute,Report1213PreviewRoute: Report1213PreviewRoute,Report1415PreviewRoute: Report1415PreviewRoute,Report1618PreviewRoute: Report1618PreviewRoute,Report18PlusPreviewRoute: Report18PlusPreviewRoute,Report18PlusPreviewPearsonRoute: Report18PlusPreviewPearsonRoute,RuTutorsSlugRoute: RuTutorsSlugRoute,RuTutorsJoinRoute: RuTutorsJoinRoute,RuTutorsMeRoute: RuTutorsMeRoute,RuTutorsSavedRoute: RuTutorsSavedRoute,StudyAbroadInviteTokenRoute: StudyAbroadInviteTokenRoute,StudyAbroadRTokenRoute: StudyAbroadRTokenRoute,AdminReviewIndexRoute: AdminReviewIndexRoute,AzBloqIndexRoute: AzBloqIndexRoute,AzTutorsIndexRoute: AzTutorsIndexRoute,EnBlogIndexRoute: EnBlogIndexRoute,EnTutorsIndexRoute: EnTutorsIndexRoute,RuTutorsIndexRoute: RuTutorsIndexRoute,AzTutorsJoinSentRoute: AzTutorsJoinSentRoute,AzTutorsMeEditRoute: AzTutorsMeEditRoute,AzXaricdeTehsilDevetTokenRoute: AzXaricdeTehsilDevetTokenRoute,AzXaricdeTehsilRTokenRoute: AzXaricdeTehsilRTokenRoute,EnStudyAbroadInviteTokenRoute: EnStudyAbroadInviteTokenRoute,EnStudyAbroadRTokenRoute: EnStudyAbroadRTokenRoute,EnTutorsJoinSentRoute: EnTutorsJoinSentRoute,EnTutorsMeEditRoute: EnTutorsMeEditRoute,RuTutorsJoinSentRoute: RuTutorsJoinSentRoute,RuTutorsMeEditRoute: RuTutorsMeEditRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)